/* eslint-disable */
import {API} from "../api";

export class LogAudit {
  constructor(acao) {
    sessionStorage.setItem('AcaoId', acao)
  }
}
